export default __webpack_public_path__ + "static/media/saved1.776b8897.svg";